import React, {Component} from 'react';
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Select from"../../local_node_modules/react-select"
import SweetAlert from 'react-bootstrap-sweetalert';
import AuthRoleCreateModal from "./components/AuthRoleCreateModal";
import AuthModulesTabView from "./components/AuthModulesTabView";
import MiniButton from "../../components/MiniButton";
import Alert from "react-s-alert";
import NavBarKS from "../../components/NavBarKS";
import SquareButtonX from "../../components/SquareButtonX";

class AuthRoles extends Component {
	constructor(props) {
		super(props);
		this.state = {
			alert: null,
			modules: [],
			customerRoleNames: [],
			authRoles: [],
			roleName: undefined,
			selectedRole: undefined,
			fetchingRole: false,
			activeTab: null,
			mode: 'edit',
			isOpen: false,
			fetchingRoleNames: false

		};
		this.fetchCustomerRoles = this.fetchCustomerRoles.bind(this);
		this.fetchData = this.fetchData.bind(this);
		this.handleCreate = this.handleCreate.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.onChangeName = this.onChangeName.bind(this);
		this.openDeleteConfirmModal = this.openDeleteConfirmModal.bind(this);
		this.onSelectRole = this.onSelectRole.bind(this);
		this.toggleTab = this.toggleTab.bind(this)
		this.toggleModal = this.toggleModal.bind(this)
		this.setAuthModule = this.setAuthModule.bind(this)
	}

	componentDidMount() {
		this.fetchCustomerRoles(undefined, undefined, undefined, undefined)
	}

	toggleTab(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	}

	toggleModal() {
		if (this.state.isOpen) {
			this.fetchCustomerRoles(undefined, undefined, undefined, undefined)
		}
		this.setState({isOpen: !this.state.isOpen});
	}

	handleCreate() {
		this.toggleModal()
	}

	handleSave() {
		let self = this;
		let params = this.createRequestParams()

		this.setState({saving: true});

		request(params).then(function (response) {

			Alert.success("Kaydedildi", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});

			self.fetchCustomerRoles(undefined,undefined,undefined,undefined)
			
		}).catch(function (error) {
			if (error.response && error.response.status === 422) {
				Alert.error(error.response.data.Exception, {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			}
			else showAxiosError(error);
		}).then(() => {
			self.setState({saving: false});
		});
	}

	onChangeName(e) {
		if (!e) return;
		e.preventDefault();

		let target = e.target;
		const value = target.value;

		this.setState({roleName: value, canSave: true})
	}

	onSelectRole(e) {
		if (!e) return;

		let value = e.value;
		let label = e.label;

		let currentRole = this.state.selectedRole
		if (currentRole === value) {
			return;
		}

		this.setState({
			selectedRole: value,
			roleName: label
		}, () => this.fetchData(undefined, undefined, undefined, undefined))
	}

	setAuthModule(value, i, j) {
		let {modules} = this.state;
		if (i === undefined && j === undefined) {
			this.setState({roleName: value, canSave: true})
		} else {
			modules[i]["privileges"][j].selected = value;
			this.setState({modules, canSave: true})
		}
	}

	handleDelete() {

		let self = this;


		let {selectedRole} = this.state

		if (selectedRole === undefined) {
			return;
		}

		let params = {
			url: `/user/removeRole/${selectedRole}`,
			method: "post",
		};

		request(params)
			.then(function (response) {
				self.setState({
					loading: false,
					alert: (
						<SweetAlert confirmBtnText="Tamam"
									showCancel={false}
									confirmBtnBsStyle="info"
									title="Kayıt silindi"
									onConfirm={() => self.setState({alert: null}, () => self.fetchCustomerRoles(undefined, undefined, undefined, undefined))}>
						</SweetAlert>
					)
				});
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	openDeleteConfirmModal() {
		this.setState({
			alert: (
				<SweetAlert showCancel warning
							confirmBtnText="Evet"
							cancelBtnText="Hayır"
							confirmBtnBsStyle="danger"
							cancelBtnBsStyle="default"
							title="Emin Misiniz?"
							onConfirm={() => this.handleDelete()}
							onCancel={() => this.setState({alert: null})}
				>
					{this.state.roleName + " grubu silinecek."}
				</SweetAlert>
			)
		})
	}

	fetchCustomerRoles(accessor, direction, page, size) {
		let self = this;

		let params = {
			url: `/user/fetchCustomerRoles`,
			method: "get",
		};

		self.setState({fetchingRoleNames: true});
		request(params)
			.then(function (response) {
				let customerRoleNames = response.data.customerRoleNames;

				if (customerRoleNames.length === 0) {
					self.setState({
						customerRoleNames: customerRoleNames,
						selectedRole: undefined,
						roleName: undefined,
						fetchingRoleNames: false,
					});
				} else {
					self.setState({
						customerRoleNames: customerRoleNames,
						selectedRole: customerRoleNames[0].recordId,
						roleName: customerRoleNames[0].roleName,
						fetchingRoleNames: false,
					}, () => self.fetchData(undefined, undefined, undefined, undefined));
				}

			}).catch(function (error) {
			self.setState({fetchingRoleNames: false});
			showAxiosError(error);
		});
	}


	fetchData(accessor, direction, page, size) {
		let self = this;
		let roleId = this.state.selectedRole

		if (!roleId)
			return;

		let params = {
			url: `/user/fetchRoles/${roleId}`,
			method: "get",
		};
		self.setState({fetchingRole:true});
		request(params)
			.then(function (response) {
				let roles = response.data.roles;
				let modules = roles.modules;
				self.setState({
					modules: modules,
					activeTab: modules ? modules[0].id : null,
					fetchingRole: false,
				});
			}).catch(function (error) {
			self.setState({fetchingRole: false});
			showAxiosError(error);
		});
	}

	createRequestParams() {

		let {selectedRole} = this.state;
		let data = {}
		data.id = selectedRole
		data.name = this.state.roleName
		data.modules = this.state.modules

		let params = {
			url: `/user/updateRole/${selectedRole}`,
			method: 'post',
			data: data
		};

		return params;
	}

	render() {
		let {modules, activeTab, customerRoleNames, roleName, canSave, saving} = this.state;
		return <div className="row baseBackground">
			<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
				<SquareButtonX position="leftSide" onClick={this.handleCreate} img="plus_sign.png" label="Yeni Oluştur"/>
			</NavBarKS>
			{this.state.alert}
			<div className="col-md-12 satirBasi">
				<div className="">
					<div className="card-header ">
						<h4 className="card-title">Yetki Grupları</h4>
					</div>
					<div className="card-body">
						<div className="col-sm-12 row">
							<div className="col-sm-4">
								<Select
									wrapperStyle={{display: 'inlineFlex'}}
									clearable={false}
									searchable={true}
									className="listt"
									value={this.state.selectedRole}
									placeholder="Seçiniz..."
									onChange={e => this.onSelectRole(e)}
									options={customerRoleNames.map((role) => ({
											value: role.recordId,
											label: role.roleName
										})
									)}
								/>
							</div>

							<div className="col-sm-1">
								{this.state.fetchingRoleNames ?
									<i className="fas fa-spinner fa-spin"/> :
									<MiniButton faIcon="fa-trash" onClick={this.openDeleteConfirmModal}/>
								}
							</div>
						</div>
						<br/>
						{ (this.state.fetchingRoleNames || this.state.fetchingRole) ?
							<div className="col-sm-12 row">
								<i className="fas fa-spinner fa-spin"/>
							</div> :
							    this.state.customerRoleNames.length !== 0 ?
								<AuthModulesTabView modules={modules}
													activeTab={activeTab}
													roleName={roleName}
													canSave={canSave}
													tabListener={this.toggleTab}
													saveListener={this.handleSave}
													showSaveButton={true}
													saving={saving}
													listener={this.setAuthModule}
								/> :
								<h4>Tanımlanmış yetki grubu bulunamadı. <a style={{ color: '#f96332',
									textDecorationLine: 'underline',
									textDecorationColor: 'currentColor',
									textDecorationStyle: 'solid',
									cursor:'pointer'}}
									onClick={this.handleCreate}> Buradan</a> tanımlayabilirsiniz.</h4>
							}
					</div>
				</div>
			</div>
			{this.state.isOpen &&
			<AuthRoleCreateModal modal={this.state.isOpen}
								 listener={this.toggleModal}
			/>
			}
		</div>;
	}

}

export default AuthRoles;